<template>
  <v-simple-table
    fixed-header
    height="300px"
    class="simple-table-default"
  >
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left simple-table-default">
              №
            </th>
            <th class="text-left simple-table-default">
              Название
            </th>
            <th class="text-right simple-table-default nowrap">
              Кол-во
            </th>
            <th class="text-right simple-table-default">
              Цена
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in warehouse_balance.lst"
            :key="item.id"
            class="bold-border-bottom"
          >
            <td class="simple-table-default">{{ item.number }}</td>
            <td class="simple-table-default"><router-link :to="{ name: 'inventory_view', params: { id: item.inventory.id, tab: 'purchase' }}">{{ item.inventory.name }}</router-link></td>
            <td class="simple-table-default text-right">{{ item.count }}</td>
            <td class="simple-table-default nowrap text-right">{{ item.total_price|moneyFormatFilter }} р.</td>
          </tr>

          <tr>
            <td class="simple-table-default"><b>Итого:</b></td>
            <td class="simple-table-default"></td>
            <td class="simple-table-default text-right"><b>{{ warehouse_balance.count }}</b></td>
            <td class="simple-table-default nowrap text-right"><b>{{ warehouse_balance.price|moneyFormatFilter }} р.</b></td>
          </tr>

        </tbody>
      </template>
    </v-simple-table>
</template>

<script>
export default {
  props: {
    warehouse_balance: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data: function () {
    return {}
  },
  methods: {
  }
}
</script>
<style scoped>
.simple-table-default {
  background-color: #F5F5F5 !important;
  font-size: 14px !important;
}
.bold-border-bottom {
  border-bottom: 1px solid #000;
}
</style>
